const GlobalSearch = require('./GlobalSearch.jsx');

module.exports = GlobalSearch;
module.exports.GlobalSearch = GlobalSearch;
